import { Dialog } from '@busybusy/webapp-react-ui';
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import IPosition from 'types/Position';
import InspectionsForm from '../forms/SafetyInspectionsForm';

export interface ISafetyInspectionsDetailProps {
  position: IPosition;
  editable: boolean;
  onUpdate: () => Promise<any>;
}

const SafetyInspectionsDetail = (props: ISafetyInspectionsDetailProps) => {
  const { position, editable, onUpdate } = props;

  const detailOpenable = useOpenable();

  const onSubmitForm = () => {
    detailOpenable.close();
    onUpdate();
  };

  return (
    <>
      <ProDetailsItem
        title={t('Inspections')}
        onClick={detailOpenable.open}
        value={position.performInspections ? (position.manageInspections ? t('Manage') : t('Perform Only')) : t('Off')}
        hint={t(
          'Allow the user to create inspections for themselves and perform inspections assigned to them by others.'
        )}
        disabled={!editable}
      />
      <Dialog position={'center'} isOpen={detailOpenable.isOpen} onClose={detailOpenable.close}>
        <InspectionsForm
          onSubmit={onSubmitForm}
          performInspections={position.performInspections ?? false}
          manageInspections={position.manageInspections ?? false}
          positionId={position.id}
        />
      </Dialog>
    </>
  );
};

export default SafetyInspectionsDetail;
